export const BUSINESSLINE1 = 'OE Connect';
export const BUSINESSLINE2 = 'OE Conference';
export const BUSINESSLINE3 = 'Capital Markets';
export const BUSINESSLINE4 = 'Corporate Services';
export const BUSINESSLINE5 = 'Corporate StreamLinks';
export const BUSINESSLINE6 = 'Knovio';
export const BUSINESSLINE7 = 'OE Stream';
export const BUSINESSLINE8 = 'Passport';
export const BUSINESSLINE9 = 'OE Internal Training';
export const BUSINESSLINE10 = 'OETV';
export const BUSINESSLINE11 = 'Buy Side';
export const UNCHECKED = 'unchecked';
export const CHECKED = 'checked';
export const ERROR1 = 'error1';
export const INVALID_FILE_FORMAT = 'Invalid File format'
export const ACCOUNT_NAME = 'Account Name'
export const EDIT_CENTRAL_MAPPING = "Edit OE Central Mapping"
export const NEW_CENTRAL_MAPPING = 'New OE Central Mapping'
export const DISABLED = 'Disabled'
export const SYSTEM_NAME1 = 'OECentral'
export const SYSTEM_NAME2 = 'Knovio'
export const SYSTEM_NAME3 = 'Salesforce'
export const SYSTEM_NAME4 = 'Passport'
export const SYSTEM_NAME5 = 'reports'
export const REPORTS = 'Reports'
export const SALESFORCE = 'Salesforce'
export const EMPTY = ''
export const FIELD_REQUIRED = 'This Field is required.'
export const VALID_EMAIL = 'Must be a valid email address'
export const FIRSTNAME = 'First Name'
export const LASTNAME = 'Last Name'
export const EMAIL_ID = 'Email Id'
export const EDIT = 'Edit'
export const USER = 'User'
export const CLIENT_NAME = 'clientName'
export const LOADING = 'Loading... '
export const NO_USERS = 'There are no Users mapped'
export const NO_ACCOUNTS_MAPPED ='There are no Accounts mapped'
export const ID_TOKEN = "idToken"
export const SESSION_EXPIRED = "session expired"
export const ACCOUNTS = 'accounts'
export const USERS = 'users'
export const ACCOUNT_USERS = "account/users"
export const ACCOUNTS_PATH = '/accounts'
export const SALESFORCE_PATH = '/salesforce'
export const USERS_PATH = '/users'
export const EDIT_SALESFORCE_MAPPING = "Edit Salesforce Account Mapping"
export const NEW_SALESFORCE_MAPPING = 'New Salesforce Account Mapping'
export const MIDDLE = 'middle'
export const END = 'end'
export const NEW_ACCOUNT = 'New Account'
export const COMMA = ','
export const EDIT_NOTIFICATION = 'Edit Notification'
export const NEW_NOTIFICATION = 'New Notification'
export const EDIT_SYSTEM_MAPPING = 'Edit System Mapping'
export const EDIT_ACCOUNT = 'Edit Account'
export const NEW_SYSTEM_MAPPING = 'New System Mapping'
export const NEW_USER = 'New User'
export const EDIT_USER = 'Edit User'
export const BUSINESSlINE_lIST = [{ key: BUSINESSLINE1, value: UNCHECKED }, { key: BUSINESSLINE2, value: UNCHECKED }, { key: BUSINESSLINE3, value: UNCHECKED }, { key: BUSINESSLINE4, value: UNCHECKED }, { key: BUSINESSLINE5, value: UNCHECKED }, { key: BUSINESSLINE6, value: UNCHECKED }, { key: BUSINESSLINE7, value: UNCHECKED }, { key: BUSINESSLINE8, value: UNCHECKED }, { key: BUSINESSLINE9, value: UNCHECKED }, { key: BUSINESSLINE10, value: UNCHECKED }, { key: BUSINESSLINE11, value: UNCHECKED }]
export const EVENT_TYPE1 = "AGM"
export const EVENT_TYPE2 = "Analyst Marketing"
export const EVENT_TYPE3 = "Business Meetings"
export const EVENT_TYPE4 = "Conference"
export const EVENT_TYPE5 = "Deal Roadshow"
export const EVENT_TYPE6 = "Earnings Release"
export const EVENT_TYPE7 = "Expert Event"
export const EVENT_TYPE8 = "Internal Communications"
export const EVENT_TYPE9 = "Investor/Capital Markets Day"
export const EVENT_TYPE10 = "Networking Event"
export const EVENT_TYPE11 = "Non-Deal Roadshow"
export const EVENT_TYPE12 = "Onsite/Hybrid"
export const EVENT_TYPE13 = "Trade Show"
export const REJECTED="rejected"
export const EVENT_TYPE_LIST = [{ key: EVENT_TYPE1, value: UNCHECKED }, { key: EVENT_TYPE2, value: UNCHECKED }, { key: EVENT_TYPE3, value: UNCHECKED }, { key: EVENT_TYPE4, value: UNCHECKED }, { key: EVENT_TYPE5, value: UNCHECKED }, { key: EVENT_TYPE6, value: UNCHECKED }, { key: EVENT_TYPE7, value: UNCHECKED }, { key: EVENT_TYPE8, value: UNCHECKED }, { key: EVENT_TYPE9, value: UNCHECKED }, { key: EVENT_TYPE10, value: UNCHECKED }, { key: EVENT_TYPE11, value: UNCHECKED }, { key: EVENT_TYPE12, value: UNCHECKED }, { key: EVENT_TYPE13, value: UNCHECKED }]
export const OECENTRAL="OECentral"
export const OECENTRAL_PATH="/oecentral"
export const SEARCH_EXCLUDED_COLUMNS = ["integrationAcctId", "numberOfMappings"]
export const ONE_WAY_ATTENDEE_REGISTRATION_PATH = "/one-way-attendee-registration"
export const SAML_ONE_WAY_ATTENDEE_REGISTRATION_PATH = "/saml-one-way-attendee-registration"
export const CITI_SSO_IFRAME_PATH = "/citi-sso-login"
export const TEAMS = 'Teams'
export const TEAMS_PATH = '/teams'

